<template>
    <div class="detail-wrapper">
        <div class="content">
            <div class="title">
                <router-link to="/" class="back" />
                <img
                    :src="`https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/titles/${state.index}.png`"
                    alt=""
                />
            </div>
            <div
                class="detail"
                v-if="state.content"
                v-html="state.content"
            ></div>
            <div class="detail" v-else>
                <div class="blank">新闻内容为空</div>
            </div>
        </div>
        <div id="fixed-news-nav" :class="state.fixed ? `fixed` : ``">
            <ul>
                <li
                    v-for="item in NEWS"
                    :key="item.id"
                    :class="item.index == state.index ? `active` : ``"
                    @click="clickEvent(item)"
                >
                    <span>{{ item.index }}</span>
                    <h4>{{ item.title }}</h4>
                    <i>{{ item.title }}</i>
                </li>
            </ul>
            <router-link to="/" class="gohome" />
        </div>
    </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { reactive, onMounted } from "vue";
import NEWS from "@/config/news";
import { GetNewsDetail } from "@/api";

const { params } = useRoute();
const state = reactive({
    content: "",
    index: 1,
    fixed: false
});

onMounted(async () => {
    await getDetail(params.id);
    window.scrollTo({
        top: 1070,
        behavior: "smooth"
    });
    document.addEventListener("scroll", () => {
        const top = document.documentElement.scrollTop;
        if (top >= 1070) {
            state.fixed = true;
        } else {
            state.fixed = false;
        }
    });
});

const getDetail = async (id) => {
    const res = await GetNewsDetail(id);
    if (res) {
        state.content = res.Content;
        const find = NEWS.find((item) => item.id == id);
        if (find) {
            state.index = find.index;
        }
    }
};

const clickEvent = (item) => {
    if (item.index == state.index) {
        return false;
    }
    window.scrollTo({
        top: 1070,
        behavior: "smooth"
    });
    getDetail(item.id);
};
</script>

<style lang="scss">
.detail-wrapper {
    min-height: 1400px;
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/news-bg.jpg");
    background-color: #603b29;
    background-repeat: no-repeat;
    background-position: center top;
    position: relative;
    .content {
        width: 1200px;
        margin: 0px auto;
        position: relative;
    }
    .title {
        width: 1200px;
        height: 50px;
        margin: 0px auto;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 60px 0px;
        position: relative;
        img {
            height: 100%;
        }
        a {
            position: absolute;
            width: 72px;
            height: 72px;
            left: 0px;
            top: 43px;
            border: 1px solid #e4b76f;
            display: flex;
            justify-content: center;
            align-items: center;
            &::before {
                content: "";
                width: 40px;
                height: 40px;
                display: block;
                background-image: url("https://static.web.sdo.com/cqyh/pic/act/2025/0606_Join/back-icon.png");
                background-size: cover;
            }
            &:hover {
                background-color: #e4b76f;
                &::before {
                    background-image: url("https://static.web.sdo.com/cqyh/pic/act/2025/0606_Join/back-icon-hover.png");
                }
            }
        }
    }
    .detail {
        padding-bottom: 120px;
        color: #ffd675;
        margin: 0px auto;
        line-height: 40px;
        .blank {
            text-align: center;
            padding-top: 200px;
            letter-spacing: 0.6em;
        }
        img {
            display: inline-block;
            margin: 10px 10px 10px 0px;
            max-width: 80%;
        }
        p {
            position: relative;
            padding-left: 120px;
            strong {
                display: block;
                position: absolute;
                top: 7px;
                left: 0;
                width: 120px;
                height: 26px;
                line-height: 26px;
                font-weight: bold;
                text-align: center;
                &::before {
                    position: absolute;
                    content: "";
                    width: 13px;
                    height: 13px;
                    background-color: #e4b76f;
                    transform: rotate(45deg);
                    left: -2px;
                    top: 6px;
                }
            }
        }
        table {
            font-size: 14px;
            margin: 10px 0 20px 140px;
            line-height: 1.4;
            max-width: 100%;
            td {
                padding: 6px;
                border: 1px solid #e4b76f;
                vertical-align: middle;
            }
        }
    }
}
#fixed-news-nav {
    position: absolute;
    right: 20px;
    top: 0px;
    z-index: 4;
    &.fixed {
        position: fixed;
    }
    ul {
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.7),
            rgba(0, 0, 0, 0)
        );
        padding: 20px;
        li {
            display: flex;
            color: #ebce89;
            cursor: pointer;
            height: 52px;
            align-items: center;
            position: relative;
            margin-bottom: 4px;
            i {
                position: absolute;
                width: 249px;
                height: 52px;
                line-height: 52px;
                right: -40px;
                background: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/news-nav.png");
                opacity: 0;
                font-size: 20px;
                color: #492411;
                font-style: normal;
                text-indent: 2em;
                transition: 0.2s;
            }
            &.active {
                cursor: default;
                i {
                    opacity: 1;
                }
            }
            span {
                margin-right: 8px;
            }
        }
    }
    .gohome {
        display: block;
        width: 143px;
        height: 42px;
        background: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/news-gohome.png");
        cursor: pointer;
    }
}
@media only screen and (min-width: 1920px) {
    #fixed-news-nav {
        &.fixed {
            right: 50%;
            margin-right: -940px;
        }
    }
}
</style>
